import { QueryClientProvider } from "@tanstack/react-query";
import { type ReactNode, useState } from "react";
import { BrowserRouter } from "react-router-dom";

import { AuthProvider } from "@/lib/auth";

import { createQueryClient } from "./queryClient";

/**
 * Providers globales de la aplicación: el caché de datos de servidor
 * (TanStack Query), el router (React Router) y la sesión (`AuthProvider`). El
 * `QueryClient` se crea una vez por montaje (vía `useState`) para que no se
 * recree en cada render.
 *
 * `AuthProvider` va dentro de `QueryClientProvider` (hidrata `/auth/me` con
 * TanStack Query) y del router (sus consumidores usan navegación). La sede activa
 * no necesita un provider: vive en el store de módulo `lib/sede`, que el
 * `AuthProvider` sincroniza y `lib/api` lee de forma síncrona.
 */
export function Providers({ children }: { children: ReactNode }) {
  const [queryClient] = useState(createQueryClient);
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>{children}</AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
